import React, {useState, useContext} from 'react';
import {Box, Toolbar, Typography, Grid, Container, Paper} from '@mui/material';
import DashboardTile from '../../components/Tiles/DashboardTile';
import Copyright from '../../components/Common/Copyright';
import PillarTile from '../../components/Tiles/PillarTile';
import {Line} from 'recharts';
import LineChartTile from '../../components/Charts/LineChartTile';
import GlobalConstants from '../../components/GlobalConstants';
import {Context as DashboardContext} from '../../contexts/DashboardContext';

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', 'purple', '#FF5722', 'orange'];

const FinancialDashboard = ({}) => {
  const {state} = useContext(DashboardContext);
  const {
    raffleWinnings,
    pillarBreakdown,
    transactionCategoriesPerMonth,
    transactionTypesPerMonth,
    averageNetWorth,
    potentialSavings,
    appProgress,
  } = state;

  const lastMonth = potentialSavings.find(month => (month.date = '2020-04'));

  return (
    <Box
      component="main"
      sx={{
        backgroundColor: '#fff',
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
        paddingTop: '60px',
        paddingBottom: '60px',
      }}>
      <Container maxWidth="lg" sx={{mt: 4, mb: 4}}>
        <Grid container spacing={3}>
          <Grid container spacing={3}>
            {/* NET WORTH */}
            <Grid item xs={12} md={6} lg={4}>
              <DashboardTile
                bigContent={`$${averageNetWorth.toFixed(2)}`}
                header="Average Net Worth"
                height={320}
              />
            </Grid>
            {/* MONEY WON */}
            <Grid item xs={12} md={6} lg={4}>
              <DashboardTile
                bigContent={`$${raffleWinnings}`}
                header="Money awarded for good behavior"
                height={320}
              />
            </Grid>
            {/* POTENTIAL SAVINGS */}
            <Grid item xs={12} md={6} lg={4}>
              <DashboardTile
                bigContent={
                  lastMonth
                    ? `$${lastMonth.minSavings.toFixed(
                        2,
                      )} - $${lastMonth.maxSavings.toFixed(2)}`
                    : null
                }
                header="Potential Savings Last Month"
                height={320}
                bigContentStyle={{fontSize: 32}}
              />
            </Grid>
            {/* PILLARS */}
            <PillarTile
              pillar={pillarBreakdown.checking}
              linked={appProgress.completeActive}
              color={GlobalConstants.CHECKING}
              height={320}
            />
            <PillarTile
              pillar={pillarBreakdown.savings}
              linked={appProgress.completeActive}
              color={GlobalConstants.SAVINGS}
              height={320}
            />
            <PillarTile
              pillar={pillarBreakdown.credit}
              linked={appProgress.completeActive}
              color={GlobalConstants.CREDIT}
              height={320}
            />
            <PillarTile
              pillar={pillarBreakdown.debt}
              linked={appProgress.completeActive}
              color={GlobalConstants.DEBT}
              height={320}
            />
            <PillarTile
              pillar={pillarBreakdown.investment}
              linked={appProgress.completeActive}
              color={GlobalConstants.INVESTMENT}
              height={320}
            />
          </Grid>

          {/* TRANSACTIONS BY MONTH */}
          <Grid item xs={12} md={12} lg={12}>
            <LineChartTile
              header="Transaction Category Breakdown by Month"
              data={transactionCategoriesPerMonth}
              legend={true}>
              <Line
                type="monotone"
                dataKey="Transportation"
                stroke={COLORS[0]}
              />
              <Line type="monotone" dataKey="Food" stroke={COLORS[1]} />
              <Line
                type="monotone"
                dataKey="Living Expenses"
                stroke={COLORS[2]}
              />
            </LineChartTile>
          </Grid>

          {/* TRANSACTIONS BY MONTH */}
          <Grid item xs={12} md={12} lg={12}>
            <LineChartTile
              header="Transaction Types Per Month"
              data={transactionTypesPerMonth}
              legend={true}>
              <Line type="monotone" dataKey="spending" stroke={COLORS[0]} />
              <Line type="monotone" dataKey="income" stroke={COLORS[1]} />
              <Line type="monotone" dataKey="savings" stroke={COLORS[2]} />
              <Line type="monotone" dataKey="investment" stroke={COLORS[3]} />
            </LineChartTile>
          </Grid>
        </Grid>
      </Container>
      <Copyright sx={{pt: 4}} />
    </Box>
  );
};

export default FinancialDashboard;
